export enum CompetitiveChallengeType {
  COMPETITIVE_CHALLENGE_TYPE_STEPS = "COMPETITIVE_CHALLENGE_TYPE_STEPS",
  COMPETITIVE_CHALLENGE_TYPE_BICYCLE = "COMPETITIVE_CHALLENGE_TYPE_BICYCLE",
}
